import { render, staticRenderFns } from "./AppAlertsDialog.vue?vue&type=template&id=4962b842&scoped=true&"
import script from "./AppAlertsDialog.vue?vue&type=script&lang=js&"
export * from "./AppAlertsDialog.vue?vue&type=script&lang=js&"
import style0 from "./AppAlertsDialog.vue?vue&type=style&index=0&id=4962b842&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4962b842",
  null
  
)

export default component.exports